export enum RestrictionStatusEnum {
    RESTRICTION_UNKNOWN = 'RESTRICTION_UNKNOWN',
    RESTRICTION_CREATED = 'RESTRICTION_CREATED',
    RESTRICTION_REMOVED = 'RESTRICTION_REMOVED',
    RESTRICTION_PENDING_ACCEPTANCE = 'RESTRICTION_PENDING_ACCEPTANCE',
    RESTRICTION_PENDING_REVIEW = 'RESTRICTION_PENDING_REVIEW',
    RESTRICTION_ACCEPTED = 'RESTRICTION_ACCEPTED',
    RESTRICTION_APPROVED = 'RESTRICTION_APPROVED',
    RESTRICTION_BLOCKING = 'RESTRICTION_BLOCKING',
}